/**
 * Internal dependencies
 */
import metadata from "./block.json";
import { timeToString, PlayerClicked, newID, volumeMarks } from "../script";

import Cookies from "js-cookie";

/**
 * WordPress dependencies
 */

import { __, _x } from "@wordpress/i18n";
import {
  useRef,
  useEffect,
  useLayoutEffect,
  useState,
} from "@wordpress/element";

import { RangeControl } from "@wordpress/components";

import {} from "@wordpress/block-editor";

export default function Controller({ attributes, mode, isSelected }) {
  const controlsHandlers = {
    playermounted: playerMounted,
  };

  const audioHandlers = {
    loadstart: loadStart,
    play: playerChanged,
    pause: playerChanged,
    ended: playerEnded,
    timeupdate: playerChanged,
  };

  const componentProps = {};
  for (const setting in metadata.attributes) {
    const prop = metadata.attributes[setting]["attribute"];
    componentProps[prop] = attributes[setting];
  }

  if (mode === "save") {
    return (
      <div
        id={attributes.id}
        class={attributes.class}
        {...componentProps}
      >
        ElmerCat Audio Player
      </div>
    );
  }

  const controlsDiv = useRef(null);
  const audioElement = useRef(null);

  var userVolume;

  if (Cookies) {
    userVolume = parseInt(Cookies.get("volumeLevel") || "100") / 100;
    //			console.log("Cookies.get volumeLevel = " + userVolume);
  }

  const [playerList, setPlayerList] = useState([]);
  const [players, setPlayers] = useState([]);
  const [status, setStatus] = useState("stopped");
  const [trackDuration, setTrackDuration] = useState(100);
  const [trackPosition, setTrackPosition] = useState(33);
  const [volumePosition, setVolumePosition] = useState(userVolume);

  useLayoutEffect(() => {
    const elements = document.querySelectorAll(".wp-block-elmercat-player");
    for (const el in elements) {
      const element = elements[el];
      if (element.dataset) {
        for (const handler in controlsHandlers) {
          element.addEventListener(handler, controlsHandlers[handler]);
        }
      }
    }

    console.log("Controls component mounted");
  }, []);

  useEffect(() => {
    console.log("Layout - Controls component mounted");
  }, []);

  useEffect(() => {
    //	console.log("volumePosition = " + volumePosition);

    Cookies.set("volumeLevel", volumePosition * 100);
    dispatchMasterVolumeChanged();
  }, [volumePosition]);

  useEffect(() => {
    console.log("status = " + status);
    if (controlsDiv.current) {
      if (status == "stopped") {
        controlsDiv.current.classList.add("stopped");
        controlsDiv.current.classList.remove("playing", "paused");
      } else if (status == "playing") {
        controlsDiv.current.classList.add("playing");
        controlsDiv.current.classList.remove("stopped", "paused");
      } else if (status == "paused") {
        controlsDiv.current.classList.add("paused");
        controlsDiv.current.classList.remove("stopped", "playing");
      }
    }
  }, [status]);

  function playerChanged() {
    //  console.log("playerChanged ");

    if (mode !== "save") {
      var plng = 0;
      var psed = 0;

      const itemList = [];
      players.forEach((player) => {
        if (!player.paused) {
          plng += 1;
        } else if (player.currentTime != 0) {
          psed += 1;
        }

        const listItem = (
          <div class={player.paused ? "player-item" : "player-item playing"}>
            {player.currentTime != 0 && (
              <button
                data-id={player.dataset.id}
                name='stop'
                onClick={stop}
                type='button'
                tabindex='0'
                aria-label='Stop'
              />
            )}
            <button
              data-id={player.dataset.id}
              name='playPause'
              onClick={playPause}
              type='button'
              tabindex='0'
              aria-label='Play/Pause'
            />
            <span name='time'>{timeToString(player.currentTime)}</span>
            <span name='title'>
              <a href={"#" + player.dataset.id}>
                {" "}
                {player.dataset.playertitle}
              </a>
            </span>
          </div>
        );
        itemList.push(listItem);
      });

      if (plng > 0) {
        setStatus("playing");
      } else if (psed > 0) {
        setStatus("paused");
      } else {
        setStatus("stopped");
      }
      setPlayerList(itemList);
    }
  }

  function dispatchMasterVolumeChanged() {
    const evt = new CustomEvent("masterVolumeChanged", {
      bubbles: true,
      cancelable: false,
      detail: { masterVolume: volumePosition },
    });
    controlsDiv.current.dispatchEvent(evt);
  }

  function playerMounted(e) {
    const plrs = players;
    plrs.push(e.detail.player);
    setPlayers(plrs);
    for (const handler in audioHandlers) {
      e.detail.player.addEventListener(handler, audioHandlers[handler]);
    }
    playerChanged();
    dispatchMasterVolumeChanged();

    console.log("playerMounted " + e.detail.player.dataset.title);
  }
  function loadStart(e) {
    console.log("loadStart - " + e.currentTarget.dataset.title);
  }
  function playAll(e) {
    players.forEach((player) => {
      player.play();

      console.log("playPauseAll - " + player.dataset.title);
    });
  }
  function pauseAll(e) {
    players.forEach((player) => {
      player.pause();

      console.log("playPauseAll - " + player.dataset.title);
    });
  }
  function stopAll(e) {
    players.forEach((player) => {
      player.pause();
      player.currentTime = 0;
      console.log("stopAll - " + player.dataset.title);
    });
  }
  function playPause(e) {
    console.log("playPause - " + e.currentTarget.dataset.id);

    const player = players.find(
      (plr) => plr.dataset.id == e.currentTarget.dataset.id
    );

    if (player.paused) {
      player.play();
    } else {
      player.pause();
    }
  }

  function stop(e) {
    const player = players.find(
      (plr) => plr.dataset.id == e.currentTarget.dataset.id
    );
    player.pause();
    player.currentTime = 0;
    console.log("stop - " + player.dataset.title);
  }
  function playerEnded(e) {
    console.log("playerEnded - " + e.currentTarget.dataset.title);
  }

  const volm = volumePosition * 100;
  const volumeLabel = "Volume: " + volm.toFixed();

  const controlsAttributes = {};
  const settings = metadata.attributes;
  for (const setting in settings) {
    const controlsSetting = settings[setting]["attribute"];
    controlsAttributes[controlsSetting] = attributes[setting];
  }

  return (
    <>
      <div
        ref={controlsDiv}
        id={attributes.id}
        class={attributes.class}
        {...componentProps}
      >
        <>
          <div class='players'>{playerList}</div>
          <div class='controls'>
            <div
              class='buttons '
              status
            >
              <button
                name='play'
                onClick={playAll}
                type='button'
                tabindex='0'
              />
              <button
                name='pause'
                onClick={pauseAll}
                type='button'
                tabindex='0'
              />{" "}
              <button
                name='stop'
                onClick={stopAll}
                type='button'
                tabindex='0'
              />
            </div>
            <RangeControl
              className='volume'
              disabled={!isSelected}
              value={volumePosition}
              max={1}
              min={0}
              marks={volumeMarks}
              showTooltip={false}
              withInputField={false}
              label={volumeLabel}
              onChange={setVolumePosition}
              step={0.01}
            />
          </div>
        </>
      </div>
    </>
  );
}
